import { contentTypes } from '../types';

import { Platform } from '@/features/pages';
import { Departments } from '@/types';

export namespace contentApiTypes {
  export type Material = {
    _id: string;
    manager: { _id: string };
    page?: { _id: string };
    name: string;
    category: string;
    type: contentTypes.ContentType;
    status: contentTypes.Status;
    filename?: string;
    mimeType?: string;
    size: number;
    url?: string;
    key?: string;
    textContent?: string;
    createdAt: number;
    updatedAt: number;
  };

  export type Category = {
    _id: string;
    page: { _id: string };
    name: string;
    createdAt: number;
    updatedAt: number;
  };

  export type ListMaterialsParams = {
    pageId: string;
    managerId?: string;
  };

  export type ListMaterialsResponse = { materials: Material[] };

  export type UploadMaterialsParams = {
    pageId: string;
    type: Exclude<contentTypes.ContentType, 'text'>;
    status: contentTypes.Status;
    category?: string;
    files: File[];
    items?: Array<{
      name?: string;
      category?: string;
      status?: contentTypes.Status;
    }>;
    managerId?: string;
  };

  export type UploadMaterialsResponse = { materials: Material[] };

  export type AddMaterialsBulkParams = {
    items: Array<{
      pageId: string;
      name: string;
      category?: string;
      type: contentTypes.ContentType;
      status: contentTypes.Status;
      textContent?: string;
      filename?: string;
      size?: number;
    }>;
    managerId?: string;
  };

  export type AddMaterialsBulkResponse = { materials: Material[] };

  export type EditMaterialParams = {
    id: string;
    name?: string;
    category?: string;
    status?: contentTypes.Status;
    textContent?: string;
    managerId?: string;
  };

  export type RemoveMaterialParams = {
    id: string;
    managerId?: string;
  };

  export type ReplaceMaterialFileParams = {
    id: string;
    file: File;
    managerId?: string;
  };

  export type ReplaceMaterialFileResponse = { material: Material };

  export type ListCategoriesParams = {
    pageId: string;
  };

  export type ListCategoriesResponse = { categories: Category[] };

  export type AddCategoryParams = {
    pageId: string;
    name: string;
  };

  export type AddCategoryResponse = { category: Category };

  export type EditCategoryParams = {
    id: string;
    name: string;
    pageId: string;
  };

  export type EditCategoryResponse = { category: Category };

  export type RemoveCategoryParams = {
    id: string;
    pageId: string;
  };
}

export function mapMaterial(
  material: contentApiTypes.Material,
  department: Departments,
  platform: Platform
): contentTypes.Item {
  return {
    _id: material._id,
    type: material.type,
    name: material.name,
    category: material.category,
    status: material.status,
    filename: material.filename,
    size: material.size,
    textContent: material.textContent,
    url: material.url,
    department,
    pageId: material.page?._id ?? '',
    platform,
    createdAt: material.createdAt,
  };
}
